import {
  createStore,
  getAgentPortalReducers,
  getAgentPortalRootSaga,
} from '@app-store'
import {
  configureSessionCrossTab,
  configureSessionPolicyStore,
  configureSessionTimerPause,
} from '@ecrm-session'

export const { store, persist } = createStore(
  getAgentPortalReducers(),
  getAgentPortalRootSaga()
)

configureSessionPolicyStore(store)
configureSessionCrossTab('agent_desk')
configureSessionTimerPause('agent_desk')
